import { render, staticRenderFns } from "./corporateGovernance.vue?vue&type=template&id=33740d24&scoped=true"
import script from "./corporateGovernance.vue?vue&type=script&lang=js"
export * from "./corporateGovernance.vue?vue&type=script&lang=js"
import style0 from "./corporateGovernance.vue?vue&type=style&index=0&id=33740d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33740d24",
  null
  
)

export default component.exports